<template>
	<div class="col-12 col-lg-8 col-xl-4 pt-4 py-lg-5 px-lg-4 d-flex" v-if="image">
		<div class="image rounded-0 flex-fill position-relative" :style="{
			'background-image': `linear-gradient(rgba(0,0,0,.3), rgba(0,0,0,.3)), url(${image})`
		}">
			<div class="p-5 d-block d-sm-none">
				<div class="p-5">
					<div class="p-5"></div>
				</div>
			</div>
	        <div class="position-absolute p-3 bottom-0 d-flex flex-column align-items-start">
	            <span class="badge text-white">Languages</span>
	            <div class="px-1">
	                <span class="badge bg-dark mx-1 fw-medium">English</span>
	                <span class="badge bg-dark mx-1 fw-medium">Afrikaans</span>
	            </div>
	        </div>
	    </div>
	</div>
	<div class="col-12 col-lg-8 col-xl-4 pt-4 py-lg-5 px-lg-4 d-flex" v-else>
		<div class="image rounded-0 flex-fill position-relative">
			<div class="p-5 d-block d-sm-none">
				<div class="p-5">
					<div class="p-5"></div>
				</div>
			</div>
			<Loader />
	    </div>
	</div>
</template>
<script>
import Loader from '@/components/Loader.vue';

export default {
	name: "AboutFrame",
	data(){
		return {
			image: null,
		}
	},
	components: {
		Loader
	},
	async mounted(){
		let resp = await fetch("https://firebasestorage.googleapis.com/v0/b/portfolio-60643.firebasestorage.app/o/IMG_7740.png?alt=media&token=a1220725-b819-44fe-a613-05966674a7a3");
		let data = await resp.blob();
		let imageUrl = URL.createObjectURL(data);
		
		this.image = imageUrl;
	}
}
</script>
<style scoped>
.image {
	background-position: top;
	background-size: cover;
	box-shadow: inset 0 0 10px 10px #212529;
}


</style>